import { generatePath } from 'react-router-dom'
import { ANALYTICS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { BarChartSquare, BarChartSquareFilled } from 'blaze-ui/icons'
import { Workspace } from 'types'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuAnalyticsItem = ({ workspace, onPress }: Props) => (
  <NavMenuItem
    icon={BarChartSquare}
    activeIcon={BarChartSquareFilled}
    to={generatePath(ANALYTICS_PATH, { workspaceId: workspace.id })}
    onPress={onPress}
    label="Analytics"
  />
)

export { NavMenuAnalyticsItem }
